/**
 * Display labels for the product filter tag IDs.
 *
 * The URL/API stores snake_case tokens (`high_protein`, `low_cholesterol`, ...).
 * These maps resolve them to the human-readable strings shown in the Filters
 * modal and in the chip row. Keep them in one place so both surfaces stay in
 * sync — including the British-English override for `high_fiber` -> `high fibre`.
 */

export const DIET_TAG_LABELS: Readonly<Record<string, string>> = {
  vegan: 'vegan',
  vegetarian: 'vegetarian',
  pescatarian: 'pescatarian',
  spicy: 'spicy',
};

export const ALLERGEN_TAG_LABELS: Readonly<Record<string, string>> = {
  allium: 'allium',
  barley: 'barley',
  dairy: 'dairy',
  egg: 'egg',
  shellfish: 'shellfish',
  soy: 'soy',
  nuts: 'nuts',
  wheat: 'wheat',
  fish: 'fish',
};

export const NUTRITION_TAG_LABELS: Readonly<Record<string, string>> = {
  high_protein: 'high protein',
  low_carbs: 'low carbs',
  complex_carbs: 'complex carbs',
  low_saturated_fat: 'low saturated fat',
  low_cholesterol: 'low cholesterol',
  low_sodium: 'low sodium',
  high_fiber: 'high fibre',
  low_sugar: 'low sugar',
  no_sugar: 'no sugar',
  no_caffeine: 'no caffeine',
};

export const SERVING_TEMPERATURE_LABELS: Readonly<Record<string, string>> = {
  warm: 'warm',
  chilled: 'chilled',
};

/** Fallback humanizer for values without an explicit mapping. */
export function humanizeFilterValue(value: string): string {
  return value.replace(/_/g, ' ');
}
